import { IButtonContainerStyles } from '@h2oai/ui-kit';

export const actionButtonStyles: IButtonContainerStyles = {
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
};
